import { DisclosureChevron, ExpandIn } from "@/components/common/Disclosure";
import { useDisclosureOpen } from "./useDisclosureOpen";

interface CompactionDividerProps {
	/** 要約本文 (生の要約テキスト)。折りたたみカード内にそのまま表示する。 */
	summaryText: string;
	/** 開閉状態を保持するための、このブロックの key。 */
	blockKey: string;
}

/**
 * 会話の自動要約が挿入された境界を示す区切り。水平線 + 中央のニュートラルな pill ラベルで
 * 「ここまでの会話は要約されました」を示し、折りたたみで要約本文を確認できる。
 */
export function CompactionDivider({ summaryText, blockKey }: CompactionDividerProps) {
	const [openByUser, setOpen] = useDisclosureOpen(`compaction:${blockKey}`);
	const open = openByUser ?? false;
	return (
		<div data-testid="compaction-divider" style={{ padding: "12px 0" }}>
			<div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
				<div style={{ flex: 1, height: 1, background: "var(--line-1)" }} />
				<span
					style={{
						flexShrink: 0,
						background: "var(--surface-1)",
						color: "var(--fg-2)",
						borderRadius: "var(--radius-full)",
						padding: "0px 10px",
						fontSize: "var(--text-caption)",
						fontWeight: 500,
						lineHeight: "var(--leading-relaxed)",
					}}
				>
					ここまでの会話は要約されました
				</span>
				<div style={{ flex: 1, height: 1, background: "var(--line-1)" }} />
			</div>
			<div
				style={{
					borderRadius: "var(--radius-4)",
					border: "1px solid var(--line-1)",
					background: "var(--surface-2)",
					padding: "8px 12px",
					fontSize: "var(--text-caption)",
					color: "var(--fg-2)",
				}}
			>
				<button
					type="button"
					onClick={() => setOpen(!open)}
					style={{
						display: "flex",
						alignItems: "center",
						gap: 4,
						width: "100%",
						textAlign: "left",
						border: 0,
						padding: 0,
						background: "transparent",
						font: "inherit",
						color: "var(--fg-2)",
						cursor: "pointer",
						userSelect: "none",
					}}
				>
					<DisclosureChevron open={open} size={11} />
					要約を表示
				</button>
				{open && (
					<ExpandIn>
						<p
							className="select-text"
							style={{
								margin: "8px 0 0",
								whiteSpace: "pre-wrap",
								overflowWrap: "anywhere",
								lineHeight: "var(--leading-body)",
							}}
						>
							{summaryText}
						</p>
					</ExpandIn>
				)}
			</div>
		</div>
	);
}
